import { useEffect, useState } from 'react'
import { useParams, NavLink, useLocation } from 'react-router-dom';
import compare from '../../images/compare.png'
import { exportPdf, maAdvisorDetails } from "../../Config/config"
import ComparePopUp from '../../Pages/ComparePopUp'
import axios from 'axios';
import { useContext } from 'react';
import { UserContext } from '../../Contexts/UserContext';
import { routeNames } from '../../routeSegments';
import RandomLogo from '../RandomLogo';
import CompanyLogo from '../CompanyLogo';
import ReadMoreReadLess from '../shared/ReadMoreReadLess';
import PdfDownloader from '../shared/PdfDownloader';
import Constants from '../../Constants';
import SendDealPopUp from '../SendDealPopUp';
import AddNotePopover from '../shared/AddNotePopover';
import AlertPopUp from '../DetailPage/AlertPopUp';
import { Tooltip } from 'antd';
import moment from "moment";
import PENotesPopup from '../../Components/NotesPopup/PENotesPopup'
import { CompareCompanyContext } from '../../Contexts/CompareCompanyContext';
import AdvisorToAllCompanies from './AdvisorToAllCompanies';
import AdvisorToAllAcquirer from './AdvisorToAllAcquirer';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import MonthPickerComponent from '../../Utils/MonthPickerComponent';


/**
 * The `AdvisorCompanyDetail` component is a React component that displays detailed information about
 * an advisor company, including an overview, companies they have invested in, acquirers they have
 * worked with, and recent news and activity. It also allows users to compare the advisor company with
 * other companies and perform various actions such as adding notes, sending deals, and downloading
 * PDFs.
 */
const AdvisorAllCompanyDetail = ({ advisorType, category }) => {

    console.log('advisorType', advisorType);

    const [showModal, setShowModal] = useState(false);
    const [note, setNote] = useState(false)
    const { advisorsId } = useParams();
    const { getToken, isStudent } = useContext(UserContext);
    const [isLoading, setIsLoading] = useState(true)
    const [advisorDetails, setAdvisorDetails] = useState({})
    const location = useLocation();
    const { setCompanyDetail, setCurrentPage } = useContext(CompareCompanyContext);
    const { setMonthPickerValue } = useContext(PeFilterContext);

    useEffect(() => {
        setMonthPickerValue(["2004-01-01", moment().endOf("month").format("YYYY-MM-DD")])
        const abortController = new AbortController();
        setIsLoading(true);
        axios.post(maAdvisorDetails, {
            "advisor_id": advisorsId,
            "advisor_type": advisorType
        }, {
            signal: abortController.signal,
            headers: { "Authorization": getToken() }
        }).then(response => {
            setIsLoading(false);
            if (response.status === 200) {
                setAdvisorDetails(response?.data?.advisor_detail ?? {})
            }
        }).catch(error => {
                console.log(error, "API Not Working")
        })

        return () =>{
            abortController.abort();
        } 
    }, [advisorType, advisorsId, getToken])

    document.title = advisorType === "L" ?
        `${advisorDetails?.advisor_profile?.advisor_name ? advisorDetails.advisor_profile.advisor_name + " - " : ""}M&A Advisors - Venture Intelligence` :
        `${advisorDetails?.advisor_profile?.advisor_name ? advisorDetails.advisor_profile.advisor_name + " - " : ""}M&A Transaction Advisors - Venture Intelligence`;

        return (
        <>
            <div className="bg-[#FFFFFF] relative">
                <nav className="flex p-1 px-4 lg:px-1 border-b " aria-label="Breadcrumb">
                    <ol className="flex items-center space-x-1">
                        <li className='flex items-center'>
                            <div className='flex items-center'>
                                <NavLink
                                    to={location.state?.prevPath != null
                                        ? location.state?.prevPath
                                        : advisorType === 'L' ? routeNames.ma_advisors : routeNames.ma_transaction_advisor}
                                    className="ml-2 text-[11pt] lg:text-[12px]  leading-[14px] font-sans_book_body text-[#666666]">
                                    Advisors
                                </NavLink>
                            </div>
                        </li>
                        <li>
                            <div className="flex items-center">
                                <span className=" text-[12px] text-[#666666] ">/</span>
                                <span className="px-1 text-[11pt] lg:text-[12px]  text-[#666666] leading-[14px] font-sans_book_body font-semibold">
                                    {advisorDetails?.advisor_profile?.advisor_name}
                                </span>
                            </div>
                        </li>
                    </ol>
                </nav>
                <div className="pl-5 pr-3">
                    <div className=" py-4 bg-[#FFFFFF]">
                        <ul>
                            <li className="w-full flex ">
                                <div className=" rounded-md">
                                    {advisorDetails?.advisor_profile?.icon_path == "default.png" || advisorDetails?.advisor_profile?.icon_path == "/default.png" || !advisorDetails?.advisor_profile?.icon_path ?
                                        <RandomLogo name={advisorDetails?.advisor_profile?.advisor_name} page="detail page" />
                                        :
                                        <CompanyLogo name={advisorDetails?.advisor_profile?.advisor_name} page="detail page" logo={advisorDetails?.advisor_profile?.icon_path} />
                                    }
                                </div>

                                <div className="ml-3 flex flex-1 flex-col">
                                    <span className="text-[#333333] text-[22px] font-semibold  leading-[24px]"> {advisorDetails?.advisor_profile?.advisor_name} </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    {/* <!-- tags--> */}
                    {advisorDetails?.advisor_profile?.about && <div className="bg-[#FFFFFF]">
                        <div className='flex items-center'>
                            <span className='text-[14px] text-[#333333] font-sans_medium_body font-medium mr-2'>About :</span>
                            <ReadMoreReadLess
                                className="text-[14px] text-[#333333] font-sans_book_body"
                                text={advisorDetails?.advisor_profile?.about}
                            />
                        </div>
                    </div>}
                </div>
            </div>
            <div>
                
                <div className="bg-[#EDEDED]  space-y-5">
                    {category === "companies" &&
                        <AdvisorToAllCompanies
                            advisorName={advisorDetails?.advisor_profile?.advisor_name}
                            showLoader={isLoading}
                            companies={advisorDetails?.to_companies_investment}
                            advisorType={advisorType}
                        />}
                    {category === "acquirers" && 
                        <AdvisorToAllAcquirer
                            advisorName={advisorDetails?.advisor_profile?.advisor_name}
                            showLoader={isLoading}
                            companies={advisorDetails?.to_acquirer_investment}
                            advisorType={advisorType}
                        />}
                    
                </div>
            </div>
            {showModal ? (<ComparePopUp entityId={advisorsId} onClose={(e) => setShowModal(false)} />) : null}
        </>
    )

}

export default AdvisorAllCompanyDetail